import {
  SAVE_SUBINFO,
  SAVE_REFUNDINFO,
  SAVE_RESERVE_NEW_SEAT,
  GET_ELE_INVOICE,
} from './actions';

const initialState = {
  status: '',
  base: {}, // 变更单信息
  progressBar: {}, // 变更进度条信息
  changePrice: {}, // 变更费用
  changNo: '', // 变更单号
  psgInfoList: [], // 变更旅客信息
  segInfoList: [], // 变更航段信息
  priceDto: {}, // 变更、退票费用明细
  changeDiscountDtoList: [], // 优惠券
  refundOrderInfo: {}, // 退票信息
  psgTicketList: [], // 混合支付
  inPsgTicketInfos: [], // 退票旅客信息
  segmentInfos: [], // 退票航段信息
  disCountOrderInfos: [], // 退票赠送的优惠券
  eleInfo: [],
  reserveSeatObj: {
    orderNo: '',
    dataSource: [],
    status: '',
    phone: '',
    vname: '',
    isBasicCabin: false, // 基础经济舱
  },
  insuranceDetailList: [], //保险信息
  auditCount: 1,
  dongHangStatus: '',
  orderRefID: '',
  totalTtPrice: 0,
  repaystatus: '',
  ticketRefundPriceDtoList: [],
  priceInfoDtos: [],
  gloOrederVo: '',
  hotelSummary: '',
  doorToDoorRefundOrder:''
};

export default function SubInfo(state = initialState, action) {
  switch (action.type) {
    case SAVE_SUBINFO:
      if (Array.isArray(action.data.changeDiscountDtoList)) {
        action.data.changeDiscountDtoList.forEach(coupon => {
          if (
            coupon.psgType === '0' ||
            coupon.psgType === '5' ||
            coupon.psgType === '6'
          ) {
            action.data.priceDto.adultPrice.faceValue
              ? (action.data.priceDto.adultPrice.faceValue +=
                coupon.discountValue)
              : (action.data.priceDto.adultPrice.faceValue =
                coupon.discountValue);
            if (
              action.data.base.changeStyle &&
              action.data.base.changeStyle.includes('退票挽留升舱')
            ) {
              action.data.priceDto.adultPrice.upfaceValue =
                action.data.priceDto.adultPrice.faceValue;
            }
          }
          if (coupon.psgType === '1' || coupon.psgType === '2') {
            action.data.priceDto.childrenPrice.faceValue
              ? (action.data.priceDto.childrenPrice.faceValue +=
                coupon.discountValue)
              : (action.data.priceDto.childrenPrice.faceValue =
                coupon.discountValue);
            if (
              action.data.base.changeStyle &&
              action.data.base.changeStyle.includes('退票挽留升舱')
            ) {
              action.data.priceDto.childrenPrice.upfaceValue =
                action.data.priceDto.childrenPrice.faceValue;
            }
          }
          if (coupon.psgType === '3') {
            action.data.priceDto.infantPrice.faceValue
              ? (action.data.priceDto.infantPrice.faceValue +=
                coupon.discountValue)
              : (action.data.priceDto.infantPrice.faceValue =
                coupon.discountValue);
          }
        });
      }

      return Object.assign({}, state, action.data, {
        refundOrderInfo: {},
        inPsgTicketInfos: [],
        segmentInfos: [],
      });
    case SAVE_REFUNDINFO:
      const {
        refundOrderInfo,
        inPsgTicketInfos,
        segmentInfos,
        priceDto,
        changeDiscountDtoList,
        refundViewDetial,
        psgTicketList,
        redemptionPredictCancelResponse,
        redemptionNoPredictCancelResponse,
        disCountOrderInfo,
        auditCount,
        dongHangStatus,
        orderRefID,
        totalTtPrice,
        repaystatus,
        ticketRefundPriceDtoList,
        priceInfoDtos,
        gloOrederVo,
        hotelSummary,
        doorToDoorRefundOrder
      } = action.data;
      return Object.assign({}, state, {
        status: '',
        base: {},
        changePrice: {},
        changNo: '',
        psgInfoList: [],
        segInfoList: [],
        refundOrderInfo,
        inPsgTicketInfos,
        segmentInfos,
        priceDto,
        redemptionPredictCancelResponse,
        redemptionNoPredictCancelResponse,
        changeDiscountDtoList,
        refundViewDetial: refundViewDetial || null,
        psgTicketList: psgTicketList || null,
        disCountOrderInfos: disCountOrderInfo || [],
        insuranceDetailList: [],
        auditCount: auditCount || 1,
        dongHangStatus,
        orderRefID,
        totalTtPrice,
        repaystatus,
        ticketRefundPriceDtoList,
        priceInfoDtos,
        gloOrederVo,
        hotelSummary,
        doorToDoorRefundOrder
      });
    case `${GET_ELE_INVOICE}_SUCCESS`:
      return Object.assign({}, state, {
        eleInfo: action.payload.data.printableTicketsRsp
          && action.payload.data.printableTicketsRsp.printableTicketsInfos
          ? action.payload.data.printableTicketsRsp.printableTicketsInfos
          : [],
      });
    case SAVE_RESERVE_NEW_SEAT:
      const reserveSeatObj = { ...state.reserveSeatObj, ...action.data };
      return Object.assign({}, state, { reserveSeatObj });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/reformProcess/modules/subInfo.js